module.exports = __webpack_public_path__ + "img/mercadopago.eac88e3e.svg";